// extracted by mini-css-extract-plugin
export default {"imgBox":"index_imgBox_ZBTpi","innerBox":"index_innerBox_0fUgY"};